import { Modal } from 'components/Modal/Modal';

import RewardsShare from 'app/_authenticated/rewards/components/RewardsShare/RewardsShare';
import { CustomLoader } from 'components/CustomLoader/CustomLoader';
import { useGetRewardDetailsQuery } from 'store/slices/rewards-api';

const RewardsModal = ({
  show,
  close,
}: {
  show: boolean;
  close: () => void;
}) => {
  const { data: rewardsDetails, isLoading } = useGetRewardDetailsQuery();

  const shareModal = isLoading ? (
    <CustomLoader />
  ) : (
    <div className="mx-0 py-0" data-testId="banner-rewards-modal">
      <div className="justify-start">
        <RewardsShare />
      </div>
    </div>
  );

  return (
    <Modal
      hideModal={close}
      width="auto"
      show={show}
      noneScrollableContent
      content={shareModal}
      closeModal={close}
    />
  );
};

export default RewardsModal;
